((document, window, history) => {
	let pushState = history.pushState;


	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let header;

	if (document.querySelector('.site-header')) {
		header = document.querySelector('.site-header').getBoundingClientRect().height;
		document.documentElement.style.setProperty('--navbar-offset', header);
		if (document.querySelector('.pre-header')) {
			header += document.querySelector('.pre-header').getBoundingClientRect().height;
		}
		document.documentElement.style.setProperty('--nav-offset', header);


		if (document.querySelector('.cast-columns')) {
			document.documentElement.style.setProperty('--cast-item', document.querySelector('.cast-item').getBoundingClientRect().height + "px");
		}
	}

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth != window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		if (document.querySelector('.site-header')) {
			header = document.querySelector('.site-header').getBoundingClientRect().height;
			document.documentElement.style.setProperty('--navbar-offset', header);
			if (document.querySelector('.pre-header')) {
				header += document.querySelector('.pre-header').getBoundingClientRect().height;
			}
			document.documentElement.style.setProperty('--nav-offset', header);
		}
		if (document.querySelector('.cast-columns')) {
			document.documentElement.style.setProperty('--cast-item', document.querySelector('.cast-item').getBoundingClientRect().height + "px");
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 300);
	
	
    // default cookie compliance script
    function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

    // default navicon
    function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active')
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

    history.pushState = function (state) {
        if (typeof history.onpushstate == "function") {
            history.onpushstate({ state: state });
        }
        return pushState.apply(history, arguments);
    };

    document.addEventListener("DOMContentLoaded", () => {
		document.documentElement.classList.add(_farlo.browser.init());
		document.querySelector("body").classList.add("loaded");

        if (document.querySelector('.site-navigation__navicon')) {
            navicon();
			document.querySelectorAll("#menu-primary-menu .menu-item a").forEach((_item) => {
				_item.addEventListener("click", () => {
					if (document.location.pathname === "/" && _item.href.match(/\#/gi)) {
						document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active')
						document.body.classList.toggle('site-navigation__nav--open');
					}
				})
			})
        }

        if (document.querySelector('.farlo-ui-biscuit-banner')) {
            cookieCompliance();
        }
    });

	function toggleFAQ(_el,force) {
		let toggled = force ?? 0;
		if (typeof force === "undefined") {
			if(_el.dataset.toggled == "0") {
				toggled = 1;
			} else {
				toggled = 0;
			}
		}
		const _answer = _el.nextElementSibling;
		if (!toggled) {
			_answer.style.height = "0px";
		} else {
			_answer.style.height = _answer.scrollHeight + "px"
		}
		_el.dataset.toggled = toggled;
	}

	const faqItem = document.querySelector(".rank-math-question");
	if (faqItem) {

		document.querySelectorAll(".rank-math-question").forEach((_el) => {
			_el.dataset.toggled = "0";
			_el.addEventListener("click", () => {
				toggleFAQ(_el);
			})
		})
		
		if (document.location.hash.match(/\#faq-[0-9]{1,2}/)) {
			window.addEventListener("load",() => {
				const faqId = parseInt(document.location.hash.split("-")[document.location.hash.split.length-1]);

				const offset = document.querySelectorAll(".rank-math-list-item")[(faqId-1)].offsetTop;
				setTimeout(() => {
					window.scrollTo(0,offset);
				},2)
				toggleFAQ(document.querySelectorAll(".rank-math-list-item")[(faqId-1)].querySelector(".rank-math-question"));

			})
		}


	}
	const lotteryTerms = document.querySelector(".lottery-terms");
	if (lotteryTerms) {
		document.querySelectorAll(".lottery-heading").forEach((_el) => {
			_el.dataset.toggled = "0";
			_el.addEventListener("click", () => {
				toggleFAQ(_el);
			})
		})
		document.querySelector("a[href='#terms']").addEventListener("click", () => {
			toggleFAQ(document.querySelector(".lottery-heading"), 1);
		});
		if (document.location.hash.match(/\#terms/gi)) {
			toggleFAQ(document.querySelector(".lottery-heading"), 1);

		}


	}


	let scrollOffset = 0;
	function scrollCast() {

		document.querySelectorAll(".cast-column-scroll").forEach((_col) => {
			scrollOffset = window.pageYOffset;
			_col.style.transform = "translateY(" +  (scrollOffset * 2) + "px)";
		});
	}

	const castColumns = document.querySelector(".cast-columns");
	if (castColumns) {

		window.addEventListener("scroll",() => {
			scrollCast();
		});
		
		document.querySelectorAll(".cast-item").forEach((_item) => {
			_item.addEventListener("click", () => {
				castColumns.classList.toggle("card-selected");
				document.querySelector("body").classList.add("cast-card-overlay__open")
				_item.classList.toggle("item-selected");
				populateCastOverlay(_item);
			})
		});
		document.querySelector(".cast-overlay").addEventListener("click", () => {
			castColumns.classList.remove("card-selected");
			document.querySelector("body").classList.remove("cast-card-overlay__open")

		})
	}

	function populateCastOverlay(_item) {
		const overlay = document.querySelector(".cast-overlay")
		overlay.querySelector("img").src = _item.querySelector("img").src;
		overlay.querySelector("h3").innerText = _item.querySelector("h4").innerText;
		overlay.querySelector("h6").innerText = _item.querySelector("p").innerText;
		overlay.querySelector(".cast-overlay__bio").innerHTML = cast_bios[_item.dataset.castIndex];
	}


	if (document.querySelector(".fade-in-text")) {
		document.querySelectorAll(".fade-in-text").forEach((_txt) => {
			let joined = [];
			_txt.querySelectorAll("p").forEach(_p => {
				let _spans = _p.innerHTML.split(" ");
				for(var i=0;i<_spans.length;i++) {
					_spans[i] = "<span class='animate-text dark'>" + _spans[i] + "</span>";
				}
				joined.push("<p>" + _spans.join(" ") + "</p>");
			});
			_txt.innerHTML = joined.join(" ");
		});
	}

	if (document.querySelector(".animate-quote")) {
		document.querySelectorAll(".animate-quote").forEach((_txt) => {
			let joined = [];
			_txt.querySelectorAll("p").forEach(_p => {
				let _spans = _p.innerHTML.split(" ");
				for(var i=0;i<_spans.length;i++) {
					_spans[i] = "<span class='animate-text dark'>" + _spans[i] + "</span>";
				}
				joined.push("<p>" + _spans.join(" ") + "</p>");
			});
			_txt.innerHTML = joined.join(" ");
		});
	}

	window.addEventListener("load", () => {
		gsap.registerPlugin(ScrollTrigger);

		document.querySelectorAll(".animate-quote").forEach(_quote => {

			gsap.fromTo(_quote.querySelectorAll(".animate-text"), {
				"will-change": "opacity",
				opacity: .6,
				color:"#fff"
			}, {
				ease: "none",
				opacity: 1,
				color:"#72bf44",

				stagger: .1,
				scrollTrigger: {
					trigger: _quote,
					start: "top bottom-=30%",
					end: "center top+=50%",
					scrub: !0,
				}
			});
		});

		
		document.querySelectorAll(".fade-in-text").forEach(_section => {

			gsap.fromTo(_section.querySelectorAll(".animate-text"), {
				"will-change": "opacity",
				opacity: .3
			}, {
				ease: "none",
				opacity: 1,
				stagger: .05,
				scrollTrigger: {
					trigger: _section,
					start: "top bottom-=10%",
					end: "center top+=10%",
					scrub: !0,
				}
			});
		});


		document.querySelectorAll(".animate-on-scroll").forEach(_elem => {

			gsap.fromTo(_elem, {
				"will-change": "transform",
				transform: "translateX(120vw)"
			}, {
				ease: "none",
				transform: "translateX(-120vw)",
				scrollTrigger: {
					trigger: _elem,
					start: "top bottom-=10%",
					end: "center top+=10%",
					scrub: !0,
				}
			});

		});

	})		

	
	function pageScroll(target,offset) {
		var elem = document.querySelector(target);
		if (elem) {
			var scroll = (window.pageYOffset + elem.getBoundingClientRect().top) - window.getComputedStyle(document.documentElement).getPropertyValue('--nav-offset');
			if (typeof offset != "undefined") {
				scroll = scroll-offset;
			}
			window.scroll({
				top : scroll,
				behavior : 'smooth'
			})

		}
	}

	document.querySelectorAll("a").forEach(elem => {
		if (elem.href) {
			if (_farlo.helpers.urls.isHash(elem)) {
				elem.addEventListener("click", (e) => {
					e.preventDefault();
					let url = elem.href.split("#");
					let selector = "#" + url[1];
					if (document.querySelector(selector)) {
						pageScroll(selector);
					} else {
						document.location.href = elem.href;
					}
				});
			}  
		}
	});
	if (document.location.hash) {
		let url = document.location.href.split("#");
		let selector = "#" + url[1];
		try {
			if (document.querySelector(selector)) {
				pageScroll(selector);
			}
		} catch(ex) {
			
		}
	}


	function mailchimpForm() {
        jQuery(document).submit(jQuery(this), function(e) {
            const $form = jQuery(e.target).closest('form');
            let $message = jQuery(e.target).closest('form').siblings('.form__message');

            e.preventDefault();

            $message.html("Adding your email address...");
            jQuery.ajax({
                url: '/app/themes/Farlo/inc/abstractions/Mailchimp/index.php',
                type: 'POST',
                data: $form.serialize() + '&ajax=true',
                success: function(msg) {
                    let message = jQuery.parseJSON(msg);
                    let result = '';

                    if (message) {
                        if (message.status === 400 && message.title === 'Member Exists') {
                            result = '<div class="form__message-text"><p>Thank you for entering the Online Lottery for  A Streetcar Named Desire. It looks as though you\'re already subscribed. Hold tight for further information.</p></div>';
                        } else if (message.status === 'pending' || message.status === 'subscribed') { // success
                            result = '<div class="form__message-text"><p>Thank you for entering the Online Lottery for  A Streetcar Named Desire. Please check your emails to confirm the subscription and we will be in touch shortly with more news!</p></div>';

                            if (typeof fdl !== 'undefined') {
                                fdl.push({
                                    "event" : "GAEvent",
                                    "eventCategory" : "Interaction",
                                    "eventAction" :  "Signup",
                                    "eventLabel" : "Success"
                                });
                            }
                        } else {
                            result = '<p>An error has occurred, please try again later.</p>';
                        }
                        
                        $message.addClass('form__message--show').html(result);
                        $form.addClass('form--hidden');
                    }
                }
            });
            return false;
        });
    }

	window.addEventListener("load", () => {
		
		document.querySelectorAll('.sign-up').forEach(() => {
			mailchimpForm();
		});
	})





	const carousel = document.querySelector(".carousel");
	if (carousel) {
		let currentSlide = 0;



		const changeSlide = function() {
			carousel.querySelectorAll(".carousel-item").forEach((_sel) => {
				_sel.classList.remove("carousel-item-active");
			});

			if(carousel.querySelectorAll(".carousel-item")[currentSlide]) {
				carousel.querySelectorAll(".carousel-item")[currentSlide].classList.add("carousel-item-active");
			} 
			if (!carousel.querySelectorAll(".carousel-item")[currentSlide+1]) {
				currentSlide=0;
			} else {
				currentSlide++;
			}

		}

		setInterval(changeSlide,3500);
		changeSlide();
	}


})(document, window, history);